import { render, staticRenderFns } from "./AddAction.vue?vue&type=template&id=06aa053e&"
import script from "./AddAction.vue?vue&type=script&lang=js&"
export * from "./AddAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports